<template>
  <activity-layout>
    <template>
      <nav-menu
        :activeTab="activeTab"
        :menuTab="menuTab"
        @change="onMenuTabChange"
        class="nav-menu"
      ></nav-menu>
      <router-view/>
      <comments class="comments"></comments>
    </template>

    <template slot="right-aside">
      <right-aside :buttonName="$t('global.上传作品')" :data="asideData" v-if="isShow"></right-aside>
    </template>
  </activity-layout>
</template>

<script>
import ActivityLayout from "@/layouts/ActivityLayout";
import NavMenu from "@/components/activity/NavMenu";
import Comments from "@/components/activity/Comments";
import RightAside from "@/components/activity/RightAside";

export default {
  name: "Match",
  components: {
    ActivityLayout,
    NavMenu,
    Comments,
    RightAside
  },
  data() {
    return {
      activeTab: "0",
      menuTab: [this.$t('global.活动介绍'), /*"$t('global.报名人员')", */this.$t('global.活动照片')],
      asideData: {
        id: Number,
        thumb: "",
        title: "",
        nickname: "",
        introduce: "",
        userId: "",
        avatar: "",
        isOfficial: Boolean,
        registrationTimeStart: Date,
        registrationTimeEnd: Date,
        holdingTimeStart: Date,
        holdingTimeEnd: Date
      },
      isShow: false
    };
  },
  watch: {
    $route: function() {
      this.changeNavMenuWithRoute();
      let currentID = this.$route.params.id;
      if (currentID == this.asideData.id) return;
      this.getRightAsideData(currentID);
    }
  },
  methods: {
    changeNavMenuWithRoute() {
      switch (this.$route.name) {
        case "activityIntroduction":
          this.activeTab = "0";
          break;
        /*case "activityParticipant":
          this.activeTab = "1";
          break;*/
        case "activityPicture":
        case "picture":
          this.activeTab = "1";
          break;
        case "activityAbout":
          this.activeTab = "2";
          break;
        default:
          this.activeTab = "0";
      }
    },

    onMenuTabChange: function(index) {
      index = Number(index);
      switch (index) {
        case 0:
          this.$router.push(`/activityDetail/${this.$route.params.id}`);
          break;
       /* case 1:
          this.$router.push("participant");
          break;*/
        case 1:
          this.$router.push(`/activityDetail/picture/${this.$route.params.id}`);
          break;
        case 2:
          this.$router.push("activityAbout");
          break;
      }
    },

    getRightAsideData(activityId) {
      this.$http
        .get("/api/activity/detail", {
          params: {
            activityId: activityId
          }
        })
        .then(data => {
          let d = data.data;
          let asideData = {};
          asideData.id = d.id;
          asideData.thumb = d.organizeAvatar;
          asideData.title = d.organizeName || `MANA${this.$t('global.全球艺术网络科技')}`;
          asideData.isOfficial = true;
          asideData.info = d.organizeInfo;
          asideData.registrationTimeStart = new Date(d.signStartTime);
          asideData.registrationTimeEnd = new Date(d.signEndTime);
          asideData.holdingTimeStart = new Date(d.holdStartTime);
          asideData.holdingTimeEnd = new Date(d.holdEndTime);
          asideData.status = d.status;
          asideData.avatar = d.avatar;
          asideData.introduce = d.introduce;
          asideData.nickname = d.nickname;
          asideData.userId = d.userId;
          this.asideData = asideData;
          this.isShow = true;
        });
    },

    getCommentsData() {
      // TODO
    }
  },

  created() {
    this.changeNavMenuWithRoute();
    this.getRightAsideData(this.$route.params.id);
  }
};
</script>

<style lang="stylus" scoped>
.nav-menu {
  height: 1rem;
  padding: 0 40px;
}

.comments {
  margin-bottom: 0.8rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/activityWrap.vue